import React, { createContext, useState,useEffect, useContext } from 'react';
import axios from 'axios';
import {toast} from 'react-toastify'
import { Redirect } from 'react-router-dom';

export const UserContext = createContext()



const UserContextProvider =(props)=>{

    const localUser = localStorage.getItem("user");

    const[user,setUser]=useState(JSON.parse(localUser));
    const[logoutLoading,setLogoutLoading]=useState(false)
    


const login=(logindata)=>{
    axios.post("https://vsam.me/api/api.php?request=login",logindata).then(res=>{
        if(res.data.status===false){
        
             toast.error(res.data.msg)
         }
         if(res.data.status===true){
             
           setUser({
               userid:res.data.userData.user_id,
               token:res.data.userData.token
          })
          localStorage.setItem("user",
          JSON.stringify(
            {
                userid:res.data.userData.user_id,
               token:res.data.userData.token
           }
          )
          )
        

         }
     })
}




const logout = ()=>{
    setLogoutLoading(true)
    axios.post("https://vsam.me/api/api.php?request=logout",{
        "user_id":user.userid,"token":user.token
    }
    ).then(res=>{
       toast.success(res.data.string)
        localStorage.removeItem("user")
        setUser();
        setLogoutLoading(false)
    })

  
   
}



 useEffect(() => {
    
   
      window.addEventListener('storage', ()=>{
        setUser(JSON.parse(localStorage.getItem("user")))
          });
         

    
 },[] )

return(
   
    <UserContext.Provider value={{user,login,logout,logoutLoading}}>
         {user?"":<Redirect to="/account"/>} 
        {props.children}
    </UserContext.Provider>
)
}

export default UserContextProvider;